/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { injectIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  emptyTable: 'There is no {type} for this range.',
  data: 'data',
});

const TableCardNoData = ({ type, intl: { formatMessage } }) =>
  formatMessage(messages.emptyTable, {
    type: type || formatMessage(messages.data),
  });

export default injectIntl(TableCardNoData);
